class BasketItemsController {

    constructor(basket, guestnameService, messageService, loadingService) {
        this.basket = basket;
        this.guestnameService = guestnameService;
        this.messageService = messageService;
        this.loadingService = loadingService;
    }

    sumGuest (guest) {
        let total = 0;

        guest.item_details.forEach(item => {
            if (item.item_summary) {
                total += item.item_summary.price.price;

                if (item.item_children && item.item_children.length > 0) {
                    item.item_children.forEach(child => {
                        total += child.item_summary.price.price;
                    });
                }
            }
        });

        return total;
    }

    priceDifference (item) {
        if (item && item.item_summary) {
            return item.item_summary.price.price !== item.item_summary.price.original_price;
        }

        return false;
    }

    displayTime (item) {
        return item.preferred_time.substr(0, 5);
    }

    displayStaff (item) {
        if (item.integration_staff) {
            return item.integration_staff_name;
        }

        return item.integration_staff_name[0].toLowerCase() + item.integration_staff_name.substr(1);
    }

    removeGuest (guest) {
        if (this.loadingService.isLoading()) {
            return;
        }

        guest.item_details.forEach(item => {
            if (item.item_summary.minimum_guests > 1) {
                this.removeItem(item, guest, false);
            }
        });

        const index = this.basket.contents.guest_details.findIndex(basketGuest => basketGuest.id === guest.id);
        if (index > -1) {
            this.basket.contents.guest_details.splice(index, 1);
        }

        return this.submitBasket(index > -1, 'Could not remove that guest');
    }

    removeItem (item, guest, shouldSubmit = true) {
        if (this.loadingService.isLoading()) {
            return;
        }

        let index = -1;

        if (item.item_summary.minimum_guests > 1) {
            const reference = item.reference;
            this.basket.contents.guest_details.forEach(guest => {
                index = guest.item_details.findIndex(guestItem => guestItem.reference === reference);
                if (index > -1) {
                    guest.item_details.splice(index, 1);
                }
            });

        } else {
            index = guest.item_details.findIndex(guestItem => guestItem.id === item.id);
            if (index > -1) {
                guest.item_details.splice(index, 1);
            }
        }

        if (shouldSubmit) {
            return this.submitBasket(index > -1, 'Could not remove that item');
        }
    }

    removeChild (child, parent) {
        if (this.loadingService.isLoading()) {
            return;
        }

        const index = parent.item_children.findIndex(item => item.id === child.id);
        if (index > -1) {
            parent.item_children.splice(index, 1);
        }

        return this.submitBasket(index > -1, 'Could not remove that item');
    }

    submitBasket (shouldSubmit, errorMessage) {
        if (shouldSubmit) {
            this.loadingService.startLoading('submitBasket');

            this.basket.contents.option = 'reset_steps';

            return this.basket.submit('remove')
                .then(() => {
                    this.loadingService.stopLoading('submitBasket');
                });
        }

        this.messageService.failure(errorMessage);
        this.messageService.push();
        this.messageService.autoClear();
    }

    canDelete () {
        return !this.noDelete;
    }
}

BasketItemsController.$inject = ['basket', 'guestnameService', 'messageService', 'loadingService'];

export default BasketItemsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/controllers/basket.items.controller.js